module.exports = __webpack_public_path__ + "img/overview_shop_80.8ce1193d.jpg";